var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// ADV-266 — /compare in the "KONTO | 04 Vergleich" design (CompareView). The cars come from the
// compare list picked on /favourites, loaded as before (compareStore.getComparedVehicles); an empty
// list goes back to /favourites. A car can be removed while more than MIN_VEHICLES_TO_COMPARE are
// left, and "Nur Unterschiede anzeigen" (compareStore.isDiff) hides the rows where all cars agree.
// Alongside, the cars' views (the VDP's stats) for the Medien row. Not the cars' documents: every
// car-basic-data GET car/:id counts as a VDP impression (views, recently viewed).
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { translate } from 'react-i18next';
import _get from 'lodash/get';
import { PLACEHOLDER_IMAGE_SMALL_URL } from '../../../framework/constants/app';
import { MIN_VEHICLES_TO_COMPARE } from '../../../framework/constants/cars';
import UserActionsAPI from '../../../services/UserActionsAPI';
import Page from '../../containers/Page';
import CompareView from './CompareView';
import { buildCompareCars, buildCompareSections } from './compareRows';
import './ComparePage.css';
let ComparePage = class ComparePage extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { loading: true, views: {} }
        });
        Object.defineProperty(this, "getComparedCars", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { compareStore } = this.props;
                const ids = toJS(compareStore.vehiclesIDsToCompare) || [];
                Promise.all([compareStore.getComparedVehicles(), this.loadViews(ids)])
                    .then(([, views]) => {
                    const { vehiclesCompared } = this.props.compareStore;
                    if (vehiclesCompared && vehiclesCompared.length) {
                        this.setState({ loading: false, views });
                        return;
                    }
                    this.props.history.push(`/favourites`);
                });
            }
        });
        // requested next to the comparison; if it fails, the Medien row only shows the photos
        Object.defineProperty(this, "loadViews", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (ids) => {
                if (!ids.length)
                    return Promise.resolve({});
                return Promise.resolve(UserActionsAPI.getStatsData(ids))
                    .then((response) => {
                    const list = _get(response, 'data');
                    return (Array.isArray(list) ? list : []).reduce((views, item) => {
                        if (item && item.carId)
                            views[item.carId] = Number(item.totalCarImpCount) || 0;
                        return views;
                    }, {});
                })
                    .catch(() => ({}));
            }
        });
        Object.defineProperty(this, "handleRemoveItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carId) => {
                const { compareStore } = this.props;
                compareStore.removeVehicleFromCompare(carId);
                compareStore.getComparedVehicles();
            }
        });
        Object.defineProperty(this, "handleDiffMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { compareStore } = this.props;
                compareStore.setDiffMode(!compareStore.isDiff);
            }
        });
        Object.defineProperty(this, "photoOf", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (vehicle) => {
                const { imagesStore } = this.props;
                return vehicle.mainImageId ? imagesStore.getSupportedImageFormat(vehicle.id, vehicle.mainImageId, 'small') : PLACEHOLDER_IMAGE_SMALL_URL;
            }
        });
    }
    componentDidMount() {
        this.getComparedCars();
    }
    componentWillUnmount() {
        const { compareStore } = this.props;
        compareStore.setDiffMode(false);
        compareStore.clearComparedVehicles();
    }
    render() {
        const { compareStore, appStore, t } = this.props;
        const { vehiclesComparedCount, isDiff } = compareStore;
        const vehicles = toJS(compareStore.vehiclesCompared).filter(Boolean);
        return (
        // no pageProps: Page re-sends a changed pageProps without mainContentClass (and nothing reads
        // them for COMPARE — no HelmetFactory entry)
        React.createElement(Page, { page: "COMPARE", mainContentClass: "cmp-main" },
            React.createElement("div", { className: "md3" },
                React.createElement(CompareView, { t: t, cars: buildCompareCars(vehicles, this.photoOf), sections: buildCompareSections(vehicles, t, appStore.language, this.state.views), loading: this.state.loading, diffOnly: isDiff, onToggleDiff: this.handleDiffMode, onRemove: vehiclesComparedCount > MIN_VEHICLES_TO_COMPARE ? this.handleRemoveItem : undefined }))));
    }
};
ComparePage = __decorate([
    inject('compareStore', 'imagesStore', 'appStore'),
    observer
], ComparePage);
export default translate(['ComparePage', 'vehicleProps', 'autobahn'])(ComparePage);
